import { Provider } from 'react-redux'
import UIWrapper from '@doveconviene/react-sf-ui/components/UIWrapper'

import { Helmet } from 'react-helmet'
import Routes from './routes'
import App from './app.container'
import configureStore from './redux'
import { applicationInit, oneTrustInit } from './redux/actions'
import theme from './components/Layout/theme'
import { env, getCommonEnv } from './utils'
import { getEnvGmapsApiKey } from './utils/env'

const store = configureStore()

store.dispatch(oneTrustInit())
store.dispatch(applicationInit())

export default (
  <Provider store={store}>
    <UIWrapper theme={theme}>
      <Helmet>
        <title>{env('REACT_APP_WEBAPP_NAME')}</title>
        <meta property="og:title" content={`${env('REACT_APP_WEBAPP_NAME')}-${env('REACT_APP_WEBAPP_DESCRIPTION')}`} />
        <meta property="og:image" content={`${window.location.protocol}//${window.location.host}/images/logos/main-${env('REACT_APP_COUNTRY')}@2x.png`} />
        <meta name="description" content={env('REACT_APP_WEBAPP_LONG_DESCRIPTION')} />
        <script src={`https://maps.googleapis.com/maps/api/js?key=${getEnvGmapsApiKey()}&callback=initMap`} async defer />
        <script type="text/javascript">
          {'window.initMap = function() {console.info(\'Map initialized\')}'}
        </script>
        <script
          type="text/plain"
          className="optanon-category-C0004"
          src={`https://${env('REACT_APP_ADFORM_HOST')}/serving/scripts/trackpoint/async/`}
          async
        />
        <link rel="shortcut icon" href={getCommonEnv('REACT_APP_FAVICON_PATH')} />
        <link rel="manifest" href={getCommonEnv('REACT_APP_MANIFEST_PATH')} />
      </Helmet>
      <App>
        {Routes}
      </App>
    </UIWrapper>
  </Provider>
)
